"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectUserLeveragePreferences = exports.maxLeverageSelector = exports.currentLeverageSelector = void 0;
var _reselect = require("reselect");
var _marginSelectors = require("./marginSelectors");
var _instrumentPositionSelectors = require("../../selectors/instrumentPositionSelectors");
var _numberFormatter = require("../../../helpers/numberFormatter");
var _orderEntryFormConstants = require("../../../constants/sendOrder/orderEntryFormConstants");
var selectMaxLeverageFromVerificationConfig = (0, _reselect.createSelector)([_marginSelectors.instrumentVerificationLevelConfigSelector, _instrumentPositionSelectors.selectedInstrumentIdSelector, function (state, side) {
  return side;
}], function (config, instrumentId, side) {
  if (!config || !config.Instruments || !instrumentId) {
    return null;
  }
  var instrumentConfig = config.Instruments.find(function (inst) {
    return inst.InstrumentId === instrumentId;
  });
  if (!instrumentConfig) {
    return null;
  }
  var isBuy = side === _orderEntryFormConstants.buyValue || side === 'Buy' || side === 0;
  var leverageValue = isBuy ? instrumentConfig.MarginMaxLeverageLong : instrumentConfig.MarginMaxLeverageShort;
  return leverageValue;
});
var maxLeverageSelector = exports.maxLeverageSelector = (0, _reselect.createSelector)([_marginSelectors.selectMarginInstrumentConfig, selectMaxLeverageFromVerificationConfig], function (config, verificationLeverage) {
  if (verificationLeverage !== null && verificationLeverage !== undefined) {
    return (0, _numberFormatter.formatNumberToLocale)(verificationLeverage, 0);
  }
  return (0, _numberFormatter.formatNumberToLocale)(config !== null && config !== void 0 && config.InitialRequirement ? Math.round(1 / config.InitialRequirement + 1) : 0, 0);
});
var selectUserLeveragePreferences = exports.selectUserLeveragePreferences = function selectUserLeveragePreferences(state) {
  return state.margin.leverages.leverages;
};
var currentLeverageSelector = exports.currentLeverageSelector = (0, _reselect.createSelector)([selectUserLeveragePreferences, _instrumentPositionSelectors.selectedInstrumentIdSelector, function (state, side) {
  return side;
}, function (state, side) {
  return maxLeverageSelector(state, side);
}], function (leverages, instrumentId, side, maxLeverage) {
  return leverages[instrumentId] && leverages[instrumentId] <= maxLeverage ? leverages[instrumentId] : maxLeverage;
});